<template>
  <div class="as-standards-wrap">
    <!-- <div class="as-standards-wrap" v-if="standardTxt"> -->
    <div class="as-standards-title">售后标准</div>
    <div class="as-standards-content">
      {{ standardTxt || "--" }}
      <!-- 不支持7天退换货/不支持七天无理由退换货，收货时有缺陷的产品可以更换，使用过的产品出现问题由技术人员判定 -->
    </div>
  </div>
</template>
<script>
import {
  queryAsStandard //包裹列表
} from "@/models/aftersaleModel";

export default {
  name: "asStandard",
  props: ["as_number"],
  data() {
    return {
      standardTxt: "",
      loading: false
    };
  },
  watch: {
    as_number(val) {
      this.standardTxt = "";
      // console.log("as_number--", val);
      if (val) {
        this.queryStandard(val);
      }
    }
  },
  created() {
    if (this.as_number) {
      this.queryStandard(this.as_number);
    }
  },
  methods: {
    // 获取售后标准
    async queryStandard(as_number) {
      const params = {
        as_number
      };
      try {
        const res = await queryAsStandard(params);
        this.standardTxt = res || "";
        // console.log("res-----", res);
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.as-standards-wrap {
  .as-standards-title {
    font-size: 14px;
    font-weight: 500;
    margin: 16px 0 8px;
  }
  .as-standards-content {
    border: 1px solid #e9e9e9;
    padding: 12px 4px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aftersale/as-standard.vue